import React from 'react';

export const ManualEmailIcon = () => {
  return (
    <>
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="48" height="48" rx="24" fill="#E7F0FF" />
        <path
          d="M15 21.994C15 25.0587 15 29.8416 15 29.8416C15 29.8416 15 29.8416 15 29.8416C15 31.0337 16.0074 32 17.25 32H30.75C31.9926 32 33 31.0337 33 29.8416V21.4875M15 21.994C15 21.6219 15.1998 21.2761 15.5288 21.0789L24 16L32.4265 20.5469C32.7808 20.738 33 21.0976 33 21.4875M15 21.994C15.45 21.994 24 27.3314 24 27.3314L33 21.4875"
          stroke="#0071F6"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
